import { CATEGORY_ARRAY, LICENCES_ARRAY, OTHERPOSITIONS_ARRAY } from "./Positions"
import {
  COUNTRIES_ARRAY,
  PL_PROVINCES_ARRAY,
  DE_PROVINCES_ARRAY,
  BE_PROVINCES_ARRAY,
  LOCALIZATION_ARRAY,
  NL_PROVINCES_ARRAY,
  FR_PROVINCES_ARRAY,
  LT_PROVINCES_ARRAY,
  NO_PROVINCES_ARRAY,
  CZ_PROVINCES_ARRAY,
} from "./Address"
import {
  PROFILESIZE_ARRAY,
  PROFILEINDUSTRIE_ARRAY,
  PROFILESTATUS_ARRAY,
  TRUCKBRANDS_ARRAY,
} from "./ProfileInformations"
import { PLANS_ARRAY, getPlan } from "./Plan"
import { BLOGCATEGORIES_ARRAY } from "./Blog"
import { SALARY_ARRAY, PHONE_STARTS_ARRAY, PHONE_TYPES_ARRAY } from "./Account"
import { TRANSACTION_STATUS_ARRAY, TRANSACTION_METHOD_TYPE_ARRAY } from "./Transactions"
import {
  WORKTYPES_ARRAY,
  TRUCKTYPES_ARRAY,
  WORKLOCATION_ARRAY,
  LANGUAGES_ARRAY,
  DRIVINGAREAS_ARRAY,
  CURRENCY_ARRAY,
  STATUS_ARRAY,
  WORKTYPES_DRIVER_ARRAY,
  DIRECTIONS_ARRAY,
  PARAMS_DRIVER_ARRAY,
  PARAMS_OTHERS_ARRAY,
  CITIZENSHIP_ARRAY,
  CAST_ARRAY,
  YES_NO_ARRAY,
  EXPERIENCE_ARRAY,
  COMPANY_TYPE_ARRAY,
} from "./OfferInformations"

const STRING_ARRAYS = CATEGORY_ARRAY.concat(LICENCES_ARRAY)
  .concat(CURRENCY_ARRAY)
  .concat(OTHERPOSITIONS_ARRAY)
  .concat(COUNTRIES_ARRAY)
  .concat(WORKLOCATION_ARRAY)
  .concat(DIRECTIONS_ARRAY)
  .concat(TRUCKTYPES_ARRAY)
  .concat(WORKTYPES_ARRAY)
  .concat(LANGUAGES_ARRAY)
  .concat(DRIVINGAREAS_ARRAY)
  .concat(PROFILESIZE_ARRAY)
  .concat(PROFILEINDUSTRIE_ARRAY)
  .concat(PROFILESTATUS_ARRAY)
  .concat(BLOGCATEGORIES_ARRAY)
  .concat(STATUS_ARRAY)
  .concat(TRANSACTION_STATUS_ARRAY)
  .concat(TRANSACTION_METHOD_TYPE_ARRAY)
  .concat(WORKTYPES_DRIVER_ARRAY)
  .concat(PARAMS_DRIVER_ARRAY)
  .concat(PARAMS_OTHERS_ARRAY)
  .concat(CITIZENSHIP_ARRAY)

const find = (slug: string) => {
  const arr = STRING_ARRAYS
  return arr.find(el => el[1] === slug) || ["", ""]
}

const translate = (str: string) => {
  const tmp = STRING_ARRAYS.find(el => el[1] === str)
  if (tmp) {
    return tmp[0]
  }
  return str
}

export {
  CATEGORY_ARRAY,
  LICENCES_ARRAY,
  OTHERPOSITIONS_ARRAY,
  COUNTRIES_ARRAY,
  PL_PROVINCES_ARRAY,
  DE_PROVINCES_ARRAY,
  BE_PROVINCES_ARRAY,
  WORKTYPES_ARRAY,
  WORKLOCATION_ARRAY,
  DRIVINGAREAS_ARRAY,
  LANGUAGES_ARRAY,
  PROFILEINDUSTRIE_ARRAY,
  PROFILESIZE_ARRAY,
  LOCALIZATION_ARRAY,
  PLANS_ARRAY,
  CURRENCY_ARRAY,
  BLOGCATEGORIES_ARRAY,
  SALARY_ARRAY,
  PHONE_STARTS_ARRAY,
  PHONE_TYPES_ARRAY,
  PARAMS_OTHERS_ARRAY,
  NL_PROVINCES_ARRAY,
  FR_PROVINCES_ARRAY,
  LT_PROVINCES_ARRAY,
  NO_PROVINCES_ARRAY,
  CZ_PROVINCES_ARRAY,
  TRUCKTYPES_ARRAY,
  DIRECTIONS_ARRAY,
  CITIZENSHIP_ARRAY,
  TRUCKBRANDS_ARRAY,
  YES_NO_ARRAY,
  CAST_ARRAY,
  EXPERIENCE_ARRAY,
  COMPANY_TYPE_ARRAY,
  getPlan,
  find,
  translate,
}
